<template>
  <vue-recaptcha
    ref='recaptcha'
    size="checkbox"
    :sitekey="sitekey"
    :loadRecaptchaScript="true"
    @verify="onVerify"
    @expired='onExpired'
  />
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    'vue-recaptcha': VueRecaptcha
  },

  data () {
    return {
      sitekey: process.env.GOOGLE_RECAPTCHA_KEY,
      recaptchaVerified: false
    }
  },

  methods: {
    onVerify (response) {
      this.recaptchaVerified = true
      this.$emit('on-check', this.recaptchaVerified)
    },

    onExpired () {
      console.log('Expired')
    },

    resetRecaptcha () {
      this.$refs.recaptcha.reset() // Direct call reset method
    }
  }
}

</script>
